import { createNoLoadActionTypes } from './utils';

export const LOAD_MEMBER_INFO = createNoLoadActionTypes('LOAD_MEMBER_INFO');
export const SET_MEMBER_INFO_DETAILS = createNoLoadActionTypes('SET_MEMBER_INFO_DETAILS');
export const RESET_MEMBER_INFO = createNoLoadActionTypes('RESET_MEMBER_INFO');
export const GET_USER_PREFERENCE = createNoLoadActionTypes('GET_USER_PREFERENCE');
export const UPDATE_USER_PREFERENCE = createNoLoadActionTypes('UPDATE_USER_PREFERENCE');
